import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { IUserGroupDetails } from '../../user-management-interfaces';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { AddUserService } from '../add-user.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-selected-units-accesspoints',
  templateUrl: './selected-units-accesspoints.component.html',
  styleUrls: ['./selected-units-accesspoints.component.scss'],
})
export class SelectedUnitsAccesspointsComponent implements OnInit {
  formGroupUserDetail!: FormGroup;
  currentAlphabet: string | undefined;

  @Input() dialogRef?: any; //close event of parent component
  @Input() userGroup?: IUserGroupDetails[] | undefined;
  @Input() sharedData!: ISharedData;

  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() flowType!: string;
  mergedUnitsAccessPoint!: any[];

  readonly LANG_CONST = LANG_CONST;
  constructor(
    private rootFormGroup: FormGroupDirective,
    private addUserService: AddUserService,
    private localizationService: LocalizationService
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    if (this.flowType === CONSTANTS.CREATE_USER) {
      const floorName = this.sharedData?.selectedFloor?.floorName;
      const buildingName = this.sharedData?.selectedBuilding?.buildingName;
      const siteName = this.sharedData?.selectedSite?.siteId;
      const buildingId = this.sharedData?.selectedBuilding?.buildingId;
      const unitId = this.sharedData?.selectedUnit?.unitId;
      const accessPointId = this.sharedData?.selectedAccessPoint?.accessPointId;
      const unitName = this.sharedData?.selectedUnit?.unitName;
      const accessPointName =
        this.sharedData?.selectedAccessPoint?.accessPointName;
      this.mergedUnitsAccessPoint = [
        {
          floorName,
          buildingName,
          siteName,
          buildingId,
          unitId,
          accessPointId,
          unitName,
          accessPointName,
        },
      ];
    } else {
      this.mergedUnitsAccessPoint = this.addUserService.getSelectedFloorUnits();
    }

    this.userGroup = this.userGroup?.filter((groups: any) => {
      return !groups.alreadySelected;
    });
    this.mergedUnitsAccessPoint = this.mergedUnitsAccessPoint.sort(
      (a: any, b: any) => a.buildingName.localeCompare(b.buildingName)
    );

    this.formGroupUserDetail = this.rootFormGroup.control.get(
      'userDetails'
    ) as FormGroup;
  }

  /**
   * @description get selected unit access point groups
   * @returns void
   */
  getSelectedUnitAccessPoints(): any {
    this.mergedUnitsAccessPoint = this.addUserService.getSelectedFloors();
  }

  /**
   * @description navigate back button form previous step
   * @returns void
   */
  navigateBack(): void {
    if (
      this.sharedData?.selectedSite?.commonAccessControl &&
      this.flowType === CONSTANTS.ADD_USER
    ) {
      this.stepperChange.emit(6);
    } else if (this.sharedData?.selectedSite?.commonAccessControl) {
      this.stepperChange.emit(5);
    } else {
      this.stepperChange.emit(5);
    }
  }

  /**
   * @description this function responsible for building name
   * @param name {string}
   * @param index {number}
   * @returns building name
   */
  checkIfNew(name: string, index: number) {
    index === 0 ? (this.currentAlphabet = '') : null;
    if (this.currentAlphabet === name?.toLowerCase()) return false;
    this.currentAlphabet = name?.toLowerCase();
    return true;
  }
}
